"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.match.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/es.object.assign.js");
var _utils = require("@zz-biz/utils");
var _lego = require("@zz-common/lego");
var _legoBackUp = require("../utils/legoBackUp");
var _client = _interopRequireDefault(require("../utils/client"));
var _isMiniprogram = _interopRequireDefault(require("../utils/isMiniprogram"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/*
 * 获取当前操作系统
 */
var getOS = function getOS() {
  var userAgent = navigator.userAgent;
  var OS = 'PC';
  if (userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('iPad') > -1 || userAgent.indexOf('iPod') > -1) {
    OS = 'IOS';
  } else if (userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1) {
    OS = 'ANDROID';
  } else if (userAgent.match(/AppleWebKit.*Mobile.*/)) {
    OS = 'Mobile';
  }
  return OS;
};

/**
 * @function
 * @name LegoInit - 埋点初始化
 * @param {object} param 其他初始化参数，最后每一个埋点发送时都会把参数拼接到backup上
 * @desc 初始化埋点参数，依赖包：<a href="http://gitlab.zhuanspirit.com/zz-fe/common-zz-lego" target="_blank">@zz-common/lego</a>
 * @example
 * import { LegoInit } from '@zz-biz/adapter';
 * 
 * // 默认设置
 * LegoInit();
 * 
 */
var LegoInit = function LegoInit() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  try {
    // 全局初始化乐高埋点的值，默认合入backup
    var legoInfoCinfig = _objectSpread({
      os: getOS(),
      uid: _legoBackUp.Uid,
      client: _client["default"]
    }, _legoBackUp.UrlParam);
    var bizResourceId = _utils.Query.get('bizResourceId');
    if (bizResourceId) {
      legoInfoCinfig.bizResourceId = bizResourceId;
    }
    var taskId = _utils.Query.get('taskId');
    if (taskId) {
      legoInfoCinfig.taskId = taskId;
    }
    var timestamp = _utils.Query.get('timestamp');
    if (timestamp) {
      legoInfoCinfig.timestamp = timestamp;
    }
    var isTest = _utils.Query.get('isTest');
    if (isTest) {
      legoInfoCinfig.isTest = isTest;
    }
    var zzUid = _utils.Query.get('zzUid');
    if (zzUid) {
      legoInfoCinfig.zzUid = zzUid;
    }
    var firstSourceId = _utils.Query.get('firstSourceId');
    if (firstSourceId) {
      legoInfoCinfig.firstSourceId = firstSourceId;
    }
    var secondSourceId = _utils.Query.get('secondSourceId');
    if (secondSourceId) {
      legoInfoCinfig.secondSourceId = secondSourceId;
    }
    var channel = _utils.Query.get('channel');
    if (channel) {
      legoInfoCinfig.channel = channel;
    }
    var trigger = _utils.Query.get('trigger');
    if (trigger) {
      legoInfoCinfig.trigger = trigger;
    }
    // 更新活动促达来源场景
    var rpschannel = _utils.Query.get('rpschannel');
    if (rpschannel) {
      legoInfoCinfig.rpschannel = rpschannel;
    }
    // 更新活动推广计划ID
    var rpuniqueId = _utils.Query.get('rpuniqueId');
    if (rpuniqueId) {
      legoInfoCinfig.rpuniqueId = rpuniqueId;
    }
    // 全链路统计埋点
    var bizchannel = _utils.Query.get('bizchannel') || _utils.Cookie.get('bizchannel');
    if (bizchannel) {
      legoInfoCinfig.bizchannel = bizchannel;
    }
    if (/MicroMessenger/gi.test(navigator.userAgent)) {
      var t = parseInt(_utils.Query.get('__t') || 0, 10);
      var temp = 50;
      if (_isMiniprogram["default"] && t) {
        temp = t;
      }
      legoInfoCinfig.uid = !_legoBackUp.Uid ? _utils.Query.get('uid') || 0 : _legoBackUp.Uid;
      (0, _lego.legoInit)(Object.assign(legoInfoCinfig, {
        t: temp
      }, param));
    } else {
      (0, _lego.legoInit)(Object.assign(legoInfoCinfig, param));
    }
    if (bizResourceId) _utils.Cookie.set('bizResourceId', bizResourceId);
    if (taskId) _utils.Cookie.set('taskId', taskId);
    if (timestamp) _utils.Cookie.set('timestamp', timestamp);
    if (isTest) _utils.Cookie.set('isTest', isTest);
    if (zzUid) _utils.Cookie.set('zzUid', zzUid);
    if (firstSourceId) _utils.Cookie.set('firstSourceId', firstSourceId);
    if (secondSourceId) _utils.Cookie.set('secondSourceId', secondSourceId);
    if (channel) _utils.Cookie.set('channel', channel);
    if (trigger) _utils.Cookie.set('trigger', trigger);
    if (bizchannel) _utils.Cookie.set('bizchannel', bizchannel);
  } catch (err) {
    console.warn(err);
  }
};
var _default = LegoInit;
exports["default"] = _default;